export enum DurationCharacterLength {
    SingleCharacter = 1,
    TwoCharacters = 2,
    ThreeCharacters = 3,
    FourCharacters = 4,
    FiveCharacters = 5,
    SixCharacters = 6,
    SevenCharacters = 7,
    EightCharacters = 8,
    NineCharacters = 9,
    TenCharacters = 10
}